import * as Request from 'request-promise'
import { environment } from '../../environments/index.jsx'
import { CrudService  } from '../crud'
import * as _ from 'lodash'

export class AppService extends CrudService {
    constructor(){
        super("app")
    }
    async getList(){
        
    }
    
}


// WEBPACK FOOTER //
// ./src/services/crud/app.js